import { render, staticRenderFns } from "./AdhocQuestions.vue?vue&type=template&id=2c3da6e2&"
import script from "./AdhocQuestions.vue?vue&type=script&lang=js&"
export * from "./AdhocQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports